export const ROUTES = {
    home: '/',
    profile: '/profile',
    subscriptions: '/subscriptions',
    signIn: '/auth/sign-in',
    signUp: '/auth/sign-up',
    authCallback: '/auth/callback',
    tour: '/tour',
    genres: '/genres',
    fanSupport: '/fan-support',
    promoPages: '/promo-pages',
    insights: '/insights',
    toolStemSplitter: '/tools/stem-splitter',
    toolVocalRemover: '/tools/vocal-remover',
    toolVoiceExtractor: '/tools/voice-extractor',
    toolInstrumentalExtractor: '/tools/instrumental-extractor',
    toolAudioConverter: '/tools/audio-converter',
    toolMp3Cutter: '/tools/mp3-cutter',
    toolVideoToMp3: '/tools/video-to-mp3',
    toolTranscription: '/tools/transcription',
    apiLanding: '/public-api',
} as const

const withCallback = (base: string, callbackUrl?: string): string =>
    callbackUrl ? `${base}?callbackUrl=${encodeURIComponent(callbackUrl)}` : base

export const getSignInUrl = (callbackUrl?: string): string =>
    withCallback(ROUTES.signIn, callbackUrl)

export const getSignUpUrl = (callbackUrl?: string): string =>
    withCallback(ROUTES.signUp, callbackUrl)

export const ANONYMOUS_USERNAME = 'anonymous'

export const getAuthorPageUrl = ({ authorUsername }: { authorUsername: string }): string =>
    !authorUsername || authorUsername === ANONYMOUS_USERNAME ? '/' : `/${authorUsername}`

/** Category hub in search, as audio-web `getSearchCategoryPageUrl` builds it. */
export const getSearchCategoryUrl = (categoryName: string): string =>
    `/search/category/${categoryName}`

/** Genre hub, as audio-web `getGenreUrl` builds it. */
export const getGenreUrl = (slug: string): string => `${ROUTES.genres}/${slug}`

/**
 * Subgenre page. A subgenre slug is `<parent>--<sub>`; the URL carries the two halves as segments,
 * as audio-web `getSubGenreUrl` builds it.
 */
export const getSubgenreUrl = (slug: string): string => {
    const [parentSlug, subSlug] = slug.split('--')

    return `${ROUTES.genres}/${parentSlug}/${subSlug}`
}
